export enum FileTypeOptions {
  JPG = 'jpg',
  PNG = 'png',
  WEBP = 'webp',
  MP4 = 'mp4',
  GIF = 'gif',
  WEBM = 'webm',
  PDF = 'pdf',
}

export const IMAGE_SORT_ORDER_FILE_TYPE_OPTIONS: FileTypeOptions[] = [
  FileTypeOptions.JPG,
  FileTypeOptions.PNG,
  FileTypeOptions.PDF,
  FileTypeOptions.GIF,
  FileTypeOptions.WEBP,
  FileTypeOptions.MP4,
  FileTypeOptions.WEBM,
];

export const VIDEO_SORT_ORDER_FILE_TYPE_OPTIONS: FileTypeOptions[] = [
  FileTypeOptions.MP4,
  FileTypeOptions.GIF,
  FileTypeOptions.WEBM,
  FileTypeOptions.JPG,
  FileTypeOptions.PNG,
  FileTypeOptions.WEBP,
  FileTypeOptions.PDF,
];

export interface FileTypeOptionsContentData {
  id: FileTypeOptions;
  type: FileTypeOptions;
  icon: string;
  text: string;
  description: string;
  isHidden?: boolean;
}
